export default {
  title: "Create your organization to get started",
  description:
    "Setting up an organization gives you a shared hub to manage campaigns, track performance, and align with your team.",
  fields: {
    logo: "Logo (optional)",
    name: "Name",
  },
  buttons: {
    upload: "Upload",
    create: "Create organization",
  },
  logoRecommendation: "Recommended size 1:1, up to 10MB",

  // 错误消息
  errors: {
    failedToUploadLogo: "Failed to upload logo",
    fileSizeExceeded: "The file size cannot exceed 10MB!",
    failedToCreateOrganization: "Failed to create organization",
  },
  
  // 表单验证消息
  validation: {
    organizationNameRequired: "Please enter an organization name",
    nameTooLong: "Name should not exceed 256 characters.",
  },
  
  // 表单占位符
  placeholders: {
    organizationName: "Organization name",
  },
};
